import {  SlotGameType1_3 } from "../SlotGameType1_3";
// export namespace SlotGames3
// {
	export class AmazingPanda3 extends SlotGameType1_3
	{
	}
// }